import './TopNavBar.scss';

// This is what the height of one of the nav items ends up being once font-size and line-height are
// factored in. Not sure if there's a better way to dynamically define this. Edit this value if you
// need to adjust the height of a nav item for CLS!
//
// Last Updated: 8/14/2025
const NAV_ITEM_HEIGHT = '16.8px';

const TopNavBarNoContent = () => {
  return (
    <div className="topNavBar-container">
      <div className="topNavBar-container__content-wrapper">
        <div className="topNavBar-container__text-container hmf-py-xs">
          <span style={{ height: NAV_ITEM_HEIGHT }} />
        </div>
      </div>
    </div>
  );
};

export default TopNavBarNoContent;
